export default __webpack_public_path__ + "locales/sk/SMTPSettings.json?hash=f323ead07841804fe5a78a9ca096b632";